<template>
  <div style="text-align:center;">
    <table border="1" style>
      <!-- 第一行(1表) -->
      <tr style="height:100px">
        <td width="24%" colspan="2" class="titleSpan companyTitle KaiTi">河南邦泰合力管理咨询有限公司</td>
        <td width="45%" colspan="3" class="titleSpan tableTitle">质 量 事 故 投 诉 记 录</td>
        <td style="border:0" colspan="2" class="titleSpan">BTHL-GK-001</td>
      </tr>
      <tr style="height:100px">
        <td colspan="2" class="titleSpan">质量事故投诉单位</td>
        <td colspan="3" class="contentSpan">xxxxxx</td>
        <td width="10%" class="titleSpan">电话</td>
        <td width="16%" class="contentSpan">xxxxxx</td>
      </tr>
      <tr style="height:100px">
        <td width="12%" class="titleSpan">投诉人</td>
        <td width="12%" class="contentSpan">xxxxxx</td>
        <td width="20%" class="titleSpan">投诉人</td>
        <td width="20%" class="contentSpan">xxxxxx</td>
        <td width="10%" class="titleSpan">投诉日期</td>
        <td colspan="2" class="contentSpan">年月日</td>
      </tr>
      <tr style="height:100px">
        <td class="titleSpan">处理日期</td>
        <td colspan="2" class="contentSpan">xxxxxx</td>
        <td width="10%" colspan="2" class="titleSpan">项目评价报告编号</td>
        <td width="16%" colspan="2" class="contentSpan">xxxxxx</td>
      </tr>
      <tr style="height:400px">
        <td colspan="7" style="text-align:left;">
          <div class="writeRightBottomBox" style="min-height:400px">
            <div class="writeRightBottomText">
              <div>质量事故情况：</div>
              <div>{{123}}</div>
            </div>
            <div style="box-sizing:border-box;padding:10px;" class="wirteTableRow">
              <div class="pic">
                <div>接受人签字:</div>
                <img src="../../assets/image/icon_MP4@2x.png" alt />
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr style="height:100px">
        <td colspan="7" style="text-align:left;">
          <div class="writeRightBottomBox" style="min-height:100px">
            <div class="writeRightBottomText">
              <div>处理意见:</div>
              <div>{{123}}</div>
            </div>
          </div>
        </td>
      </tr>
      <tr style="height:100px">
        <td colspan="7" style="text-align:left;">
          <div class="writeRightBottomBox" style="min-height:100px">
            <div class="writeRightBottomText">
              <div>处理结果：</div>
              <div>{{123}}</div>
            </div>
            <div style="box-sizing:border-box;padding:10px;" class="wirteTableRow">
              <div class="pic">
                <div>负责人签字:</div>
                <img src="../../assets/image/icon_MP4@2x.png" alt />
              </div>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {
      // 评价类别
      pjTypeList: [
        {
          id: '1',
          label: '预评价',
        },
        {
          id: '2',
          label: '验收评价',
        },
        {
          id: '3',
          label: '现状评价',
        },
        {
          id: '4',
          label: '专项评价',
        },
        {
          id: '5',
          label: '其它',
        },
      ],
    }
  },
  computed: {
    ...mapState('process/projectTable', ['printData']),
  },
  methods: {},
  mounted() {},
  async created() {},
}
</script>
<style lang="less" scoped>
@import url(./printDialog.scss);
</style>